import React from 'react'
import MaxxLogo from 'Maxxia/images/maxxia-logo.png'
import Instagram from '../images/instagram-icon.png'
import Facebook from '../images/facebook-icon.png'
import Linkedin from '../images/linkedin-icon.png'
import Youtube from '../images/youtube-icon.png'
import RemLogo from 'RemServ/icons/remserv_main_logo.svg'
import RemLeaseLogo from 'RemServ/icons/remserv-lease-logo.svg'
import { useSelector } from 'react-redux'
import globals from 'application/constants/globals'

interface IIndexable<T = any> {
  [key: string]: T
}

const icons: IIndexable = {
  instagram: Instagram,
  maxxlogo: MaxxLogo,
  remleaselogo: RemLeaseLogo,
  remlogo: RemLogo,
  facebook: Facebook,
  linkedin: Linkedin,
  youtube: Youtube,
}

interface IInputProps {
  src: string
  alt: string
}

interface IStateProps {
  user: { isGov: boolean }
}

const Icon = ({ src, alt }: IInputProps) => {
  const isGov = useSelector((state: IStateProps) => state.user.isGov)
  if (src && src.toLowerCase() == 'logo') {
    src = globals.isBrandMX ? 'maxxlogo' : isGov ? 'remleaselogo' : 'remlogo'
  }

  return <img src={icons[src.toLowerCase()]} alt={alt} />
}

export default Icon
